if ($('.countdown-wrapper').length) {
    /**
     * COUNTDOWN COVER
     */

    // Set the date we're counting down to
    var countDownDate = new Date($('.countdown-wrapper').attr('data-countdown')).getTime();


    // Get today's date and time
    var now = new Date().getTime();

    // Find the distance between now and the count down date
    var distance = countDownDate - now;
    if (distance > 0) {


        // Update the count down every 1 second
        var x = setInterval(function () {

            // Get today's date and time
            var now = new Date().getTime();

            // Find the distance between now and the count down date
            var distance = countDownDate - now;

            // Time calculations for days, hours, minutes and seconds
            var days = formatNumber(Math.floor(distance / (1000 * 60 * 60 * 24)));
            var hours = formatNumber(Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)));
            var minutes = formatNumber(Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)));
            var seconds = formatNumber(Math.floor((distance % (1000 * 60)) / 1000));

            // Display the result in the element with id="demo"
            document.getElementById("days").innerHTML = days;
            document.getElementById("hours").innerHTML = hours;
            document.getElementById("minutes").innerHTML = minutes;
            document.getElementById("seconds").innerHTML = seconds;


            // If the count down is finished, write some text
            if (distance < 0) {
                clearInterval(x);
                document.getElementById("days").innerHTML = "00";
                document.getElementById("hours").innerHTML = "00";
                document.getElementById("minutes").innerHTML = "00";
                document.getElementById("seconds").innerHTML = "00";
            }
        }, 1000);
    }

}

function formatNumber(number) {
    return number < 10 ? "0" + number : number;

}

//home change header color on scroll
// $(window).scroll(function() {
//     var scroll = $(window).scrollTop();
//     if (scroll >= 100) {
//         $(".home .site-header").addClass('bg-white').removeClass('bg-none');
//     } else {
//         $(".home .site-header").removeClass('bg-white').addClass('bg-none');
//     }
// })

function getLanguageCode() {
    var path = window.location.pathname;
    var languageCode = path.split('/')[1];

    return languageCode;
}

if (getLanguageCode() == 'fr') {
    var folgt = 'Suit';
} else if (getLanguageCode() == 'en') {
    var folgt = 'Follows';
} else {
    var folgt = 'Folgt';
}

$(document).on('mouseenter', '.disabled-item', function (e) {
    if ($(this).find('.menu-disabled-folgt').length == 0) {
        $(this).find('a').hide();
        $(this).append('<a href="#" class="menu-disabled-folgt">' + folgt + '</a>');
    }

});
$(document).on('mouseleave', '.disabled-item', function () {
    $(this).find('a').show();
    $(this).find('.menu-disabled-folgt').remove();
});

$(document).on('click', '.newsletter-close', function () {
    $('.newsletter--box--wrap').hide();
    //hier Cookie setzen
});
//dropdown function
$('.menu-top .menu-item-has-children').each(function () {
    $(this).children('a').addClass('dropdown-link');
});

$(document).on('click', '.dropdown-link', function (e) {
    e.preventDefault();

    var $this = $(this);
    $(".dropdown-link").next().not($this.next()).removeClass('dropdown');
    $(".dropdown-link").next().not($this.next()).slideUp();
    if ($this.next().hasClass('dropdown')) {
        $this.next().removeClass('dropdown');
        $this.next().slideUp();
    } else {
        $this.next().addClass('dropdown');
        $this.next().slideDown();
    }
});

// //close dropdown if click on page
$(document).mouseup(function (e) {
    var container = $(".sub-menu, .dropdown-link");
    if (!container.is(e.target) && container.has(e.target).length === 0) {
        $(".dropdown-link").next().removeClass('dropdown');
        $(".dropdown-link").next().slideUp();
    }
});


$('.mobile--inner--wrapper .menu-item-has-children').each(function () {
    $(this).addClass('acc-submenu');
});
$(document).on('click', '.mobile--inner--wrapper .acc-submenu > a', function (e) {
    e.preventDefault();
    var $this = $(this);
    $this.toggleClass('rotate');
    $this.next().toggleClass('acc--menu--open');
    $this.next().slideToggle('slow');
});




let isAnimating = false;
$(document).on('click', '.burger--menu--toggle', function (e) {
    e.preventDefault();
    e.stopPropagation();

    if (isAnimating) {
        return;
    }

    var $this = $(this);
    isAnimating = true;

    //mobile menu animation
    if (!$('.header-mobile-content').hasClass("header--open")) {
        //burger toggle animation
        $this.addClass("burger--closed");
        $('body').addClass('nav--open');


        //open menu
        $('.header-mobile-content').addClass("header--open").removeClass("header--closed");
        $('html, body').css({
            overflow: 'hidden',
        });
    } else {
        //burger toggle animation
        $this.removeClass("burger--closed");
        $('body').removeClass('nav--open');

        //close menu
        $('.header-mobile-content').removeClass("header--open").addClass("header--closed");
        $('html, body').css({
            overflow: '',
        });

        // close submenus
        // $('#menu-main .dropdown-menu').removeClass('menu--slide--in');
        // $('#menu-main .dropdown-menu').slideUp('slow');
    }

    setTimeout(function () {
        // enable click after 1 second
        isAnimating = false;
    }, 500); // .5 second delay

});



// //close menu if click on page
$(document).mouseup(function (e) {
    var container = $(".header--open, .header--burger");

    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0) {
        $('.header-mobile-content').removeClass("header--open");
        $('.burger--menu--toggle').removeClass('burger--closed');
        $('html, body').css({
            overflow: '',
        });
        $('body').removeClass('nav--open');

        // close submenus
        // $('#menu-main .dropdown-menu').removeClass('menu--slide--in');
        // $('#menu-main .dropdown-menu').slideUp('slow');
    }
});

// Close mobile menu when any link is clicked (except dropdown toggles)
$(document).on('click', '.header-mobile-content a', function(e) {
    // Don't close menu if this is a dropdown toggle link
    if (!$(this).parent().hasClass('menu-item-has-children')) {
        // Close the mobile menu
        $('.header-mobile-content').removeClass("header--open").addClass("header--closed");
        $('.burger--menu--toggle').removeClass('burger--closed');
        $('html, body').css({
            overflow: '',
        });
        $('body').removeClass('nav--open');
    }
});

// Handle hash links - redirect to homepage if not already there
$(document).on('click', '.header-mobile-content a, .menu-top a', function(e) {
    var href = $(this).attr('href');

    // Check if this is a hash link (starts with #)
    if (href && href.startsWith('#')) {
        // Check if we're not on the homepage
        if (window.location.pathname !== '/' && window.location.pathname !== '/index.php') {
            e.preventDefault();
            // Redirect to homepage with the hash
            window.location.href = '/' + href;
        }
    }
});

//hide navbar on scroll
$(function () {
    var lastScrollTop = 0,
        delta = 5;
    $(window).scroll(function () {
        var nowScrollTop = $(this).scrollTop();
        var scroll = $(window).scrollTop();

        if (Math.abs(lastScrollTop - nowScrollTop) >= delta) {
            if (nowScrollTop > lastScrollTop) {
                // SCROLLING DOWN
                if (scroll >= 600) {
                    $('.site-header').removeClass('nav-down').addClass('nav-up');
                }
            } else {
                // SCROLLING UP
                $('.site-header').removeClass('nav-up').addClass('nav-down');
            }
            lastScrollTop = nowScrollTop;
        }
    });
});
